export default __webpack_public_path__ + "static/media/arrow_up.e2e45ef3.svg";